var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 51,
    viewBox: "0 0 150 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47043 27.2979L3.37701 22.0512C1.29509 16.8333 2.22805 10.8951 5.80974 6.56697C8.72763 3.04102 13.0659 1 17.6427 1H23.2531C25.1073 1 26.9567 1.18901 28.7726 1.5641L38.4621 3.56559C41.4454 4.18184 44.3045 5.29358 46.9205 6.85464L49.2996 8.27433C52.7978 10.3619 55.5288 13.5229 57.0864 17.2871L57.2858 17.7691C60.377 25.2398 58.1759 33.8541 51.8798 38.9262C48.641 41.5353 44.6072 42.958 40.4482 42.958H28.5794C18.3978 42.958 9.24359 36.7546 5.47043 27.2979Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.53 27.2979L121.623 22.0512C123.705 16.8333 122.772 10.8951 119.19 6.56697C116.272 3.04102 111.934 1 107.357 1H101.747C99.8927 1 98.0433 1.18901 96.2274 1.5641L86.5379 3.56559C83.5546 4.18184 80.6955 5.29358 78.0795 6.85464L75.7004 8.27433C72.2022 10.3619 69.4712 13.5229 67.9136 17.2871L67.7142 17.7691C64.623 25.2398 66.8241 33.8541 73.1202 38.9262C76.359 41.5353 80.3928 42.958 84.5518 42.958H96.4206C106.602 42.958 115.756 36.7546 119.53 27.2979Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 25.4755H65.625",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4102 8.86713C20.425 8.9999 20.6057 9.50342 20.3125 9.52272C20.0568 9.53955 19.6629 9.66999 19.9219 9.95978",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8242 12.1451C19.9773 12.1665 20.1514 12.5494 20.2148 12.6914",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8242 15.2045C20.1544 15.2045 20.1172 15.4548 20.1172 15.7509",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9219 18.5918C20.072 18.7597 20.2371 19.0413 20.4102 19.1381",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1172 21.2142C20.1172 21.6551 20.0134 21.9859 19.7266 22.3068",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 23.618C20.3125 23.9287 20.2873 24.2331 20.0195 24.3829",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9219 27.333H20.1172",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2148 29.2998V29.5184",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8242 31.2666V31.4851",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6836 7.99301C25.6984 8.12578 25.8791 8.62931 25.5859 8.64861C25.3302 8.66544 24.9363 8.79588 25.1953 9.08567",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0977 11.271C25.2508 11.2924 25.4248 11.6752 25.4883 11.8173",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0977 14.3304C25.4279 14.3304 25.3906 14.5807 25.3906 14.8767",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1953 17.7177C25.3454 17.8856 25.5105 18.1672 25.6836 18.264",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3906 20.34C25.3906 20.781 25.2869 21.1117 25 21.4327",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5859 22.7439C25.5859 23.0545 25.5607 23.3589 25.293 23.5087",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1953 26.4589H25.3906",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4883 28.4257V28.6442",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0977 30.3925V30.611",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9336 7.99301C31.9484 8.12578 32.1291 8.62931 31.8359 8.64861C31.5802 8.66544 31.1863 8.79588 31.4453 9.08567",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3477 11.271C31.5008 11.2924 31.6748 11.6752 31.7383 11.8173",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3477 14.3304C31.6779 14.3304 31.6406 14.5807 31.6406 14.8767",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4453 17.7177C31.5954 17.8856 31.7605 18.1672 31.9336 18.264",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6406 20.34C31.6406 20.781 31.5369 21.1117 31.25 21.4327",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8359 22.7439C31.8359 23.0545 31.8107 23.3589 31.543 23.5087",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4453 26.4589H31.6406",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7383 28.4257V28.6442",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3477 30.3925V30.611",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1836 14.986C38.1984 15.1188 38.3791 15.6223 38.0859 15.6416C37.8302 15.6584 37.4363 15.7889 37.6953 16.0787",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5977 18.264C37.7508 18.2854 37.9248 18.6682 37.9883 18.8103",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5977 21.3234C37.9279 21.3234 37.8906 21.5737 37.8906 21.8697",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6953 24.7106C37.8454 24.8786 38.0105 25.1602 38.1836 25.257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8906 27.333C37.8906 27.774 37.7869 28.1047 37.5 28.4257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0859 29.7369C38.0859 30.0475 38.0607 30.3519 37.793 30.5017",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6953 33.4519H37.8906",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9883 35.4187V35.6372",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5977 37.3855V37.604",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4336 14.986C44.4484 15.1188 44.6291 15.6223 44.3359 15.6416C44.0802 15.6584 43.6863 15.7889 43.9453 16.0787",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8477 18.264C44.0008 18.2854 44.1748 18.6682 44.2383 18.8103",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8477 21.3234C44.1779 21.3234 44.1406 21.5737 44.1406 21.8697",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9453 24.7106C44.0954 24.8786 44.2605 25.1602 44.4336 25.257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1406 27.333C44.1406 27.774 44.0369 28.1047 43.75 28.4257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3359 29.7369C44.3359 30.0475 44.3107 30.3519 44.043 30.5017",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9453 33.4519H44.1406",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2383 35.4187V35.6372",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8477 37.3855V37.604",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6836 14.986C50.6984 15.1188 50.8791 15.6223 50.5859 15.6416C50.3302 15.6584 49.9363 15.7889 50.1953 16.0787",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0977 18.264C50.2508 18.2854 50.4248 18.6682 50.4883 18.8103",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0977 21.3234C50.4279 21.3234 50.3906 21.5737 50.3906 21.8697",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1953 24.7106C50.3454 24.8786 50.5105 25.1602 50.6836 25.257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3906 27.333C50.3906 27.774 50.2869 28.1047 50 28.4257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5859 29.7369C50.5859 30.0475 50.5607 30.3519 50.293 30.5017",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1953 33.4519H50.3906",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4883 35.4187V35.6372",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0977 37.3855V37.604",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M105.342 8.86713C105.327 8.9999 105.146 9.50342 105.44 9.52272C105.695 9.53955 106.089 9.66999 105.83 9.95978",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M105.928 12.1451C105.775 12.1665 105.601 12.5494 105.537 12.6914",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M105.928 15.2045C105.598 15.2045 105.635 15.4548 105.635 15.7509",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M105.83 18.5918C105.68 18.7597 105.515 19.0413 105.342 19.1381",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M105.635 21.2142C105.635 21.6551 105.739 21.9859 106.026 22.3068",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M105.44 23.618C105.44 23.9287 105.465 24.2331 105.733 24.3829",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M105.83 27.333H105.635",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M105.537 29.2998V29.5184",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M105.928 31.2666V31.4851",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M100.069 7.99301C100.054 8.12578 99.873 8.62931 100.166 8.64861C100.422 8.66544 100.816 8.79588 100.557 9.08567",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M100.655 11.271C100.501 11.2924 100.327 11.6752 100.264 11.8173",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M100.655 14.3304C100.324 14.3304 100.362 14.5807 100.362 14.8767",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M100.557 17.7177C100.407 17.8856 100.242 18.1672 100.069 18.264",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M100.362 20.34C100.362 20.781 100.465 21.1117 100.752 21.4327",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 22.7439C100.166 23.0545 100.191 23.3589 100.459 23.5087",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M100.557 26.4589H100.362",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M100.264 28.4257V28.6442",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M100.655 30.3925V30.611",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8186 7.99301C93.8038 8.12578 93.623 8.62931 93.9163 8.64861C94.172 8.66544 94.5659 8.79588 94.3069 9.08567",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4045 11.271C94.2514 11.2924 94.0774 11.6752 94.0139 11.8173",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4045 14.3304C94.0743 14.3304 94.1116 14.5807 94.1116 14.8767",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3069 17.7177C94.1568 17.8856 93.9916 18.1672 93.8186 18.264",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1116 20.34C94.1116 20.781 94.2153 21.1117 94.5022 21.4327",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9163 22.7439C93.9163 23.0545 93.9415 23.3589 94.2092 23.5087",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3069 26.4589H94.1116",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0139 28.4257V28.6442",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4045 30.3925V30.611",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5686 14.986C87.5538 15.1188 87.373 15.6223 87.6663 15.6416C87.922 15.6584 88.3159 15.7889 88.0569 16.0787",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1545 18.264C88.0014 18.2854 87.8274 18.6682 87.7639 18.8103",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1545 21.3234C87.8243 21.3234 87.8616 21.5737 87.8616 21.8697",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0569 24.7106C87.9068 24.8786 87.7416 25.1602 87.5686 25.257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8616 27.333C87.8616 27.774 87.9653 28.1047 88.2522 28.4257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6663 29.7369C87.6663 30.0475 87.6915 30.3519 87.9592 30.5017",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0569 33.4519H87.8616",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7639 35.4187V35.6372",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1545 37.3855V37.604",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3186 14.986C81.3038 15.1188 81.123 15.6223 81.4163 15.6416C81.672 15.6584 82.0659 15.7889 81.8069 16.0787",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9045 18.264C81.7514 18.2854 81.5774 18.6682 81.5139 18.8103",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9045 21.3234C81.5743 21.3234 81.6116 21.5737 81.6116 21.8697",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8069 24.7106C81.6568 24.8786 81.4916 25.1602 81.3186 25.257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6116 27.333C81.6116 27.774 81.7153 28.1047 82.0022 28.4257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4163 29.7369C81.4163 30.0475 81.4415 30.3519 81.7092 30.5017",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8069 33.4519H81.6116",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5139 35.4187V35.6372",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9045 37.3855V37.604",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0686 14.986C75.0538 15.1188 74.873 15.6223 75.1663 15.6416C75.422 15.6584 75.8159 15.7889 75.5569 16.0787",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6545 18.264C75.5014 18.2854 75.3274 18.6682 75.2639 18.8103",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6545 21.3234C75.3243 21.3234 75.3616 21.5737 75.3616 21.8697",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5569 24.7106C75.4068 24.8786 75.2416 25.1602 75.0686 25.257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3616 27.333C75.3616 27.774 75.4653 28.1047 75.7522 28.4257",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1663 29.7369C75.1663 30.0475 75.1915 30.3519 75.4592 30.5017",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5569 33.4519H75.3616",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2639 35.4187V35.6372",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6545 37.3855V37.604",
    stroke: "#00FF41",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M135.336 37.8966C135.336 41.7242 124.516 48.9856 112.557 49.9097C100.029 48.0616 89.7781 42.1864 89.7781 38.3588C89.7781 34.5312 100.598 29.2345 112.557 37.0888C122.238 29.2345 135.336 34.0689 135.336 37.8966Z",
    fill: "#CA0808"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M111.9 37.5486C105.245 32.8359 96.8589 32.5558 89.9987 36.7084C89.6914 36.6012 89.3847 36.4918 89.0784 36.3801C96.0464 31.8101 104.683 31.8314 111.636 36.4441L111.389 36.6283L111.619 37.015L111.918 37.5175L111.9 37.5486ZM113.082 37.5175L113.381 37.015L113.611 36.6283L113.364 36.4441C120.317 31.8314 128.954 31.8101 135.922 36.3801C135.615 36.4918 135.309 36.6012 135.001 36.7084C128.141 32.5558 119.755 32.8359 113.1 37.5486L113.082 37.5175ZM90.1222 37.8088C104.709 42.7863 120.291 42.7863 134.878 37.8088C134.887 37.8144 134.895 37.82 134.904 37.8255C134.571 38.2228 134.232 38.6091 133.887 38.9845C119.913 43.4907 105.087 43.4907 91.1134 38.9844C90.7681 38.6091 90.4288 38.2228 90.0959 37.8256C90.1047 37.82 90.1134 37.8144 90.1222 37.8088ZM90.5569 39.8552C102.791 52.952 122.209 52.952 134.443 39.8552C134.903 39.7051 135.362 39.5501 135.82 39.3903C123.107 54.2033 101.893 54.2032 89.1799 39.3902C89.638 39.55 90.0969 39.705 90.5569 39.8552Z",
    fill: "#CA0808",
    stroke: "black",
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M130.136 19.4965H126.011V7.86014H130.17C131.341 7.86014 132.348 8.0931 133.193 8.55901C134.038 9.02113 134.688 9.6859 135.142 10.5533C135.6 11.4207 135.83 12.4586 135.83 13.667C135.83 14.8791 135.6 15.9207 135.142 16.792C134.688 17.6632 134.034 18.3317 133.182 18.7976C132.333 19.2636 131.318 19.4965 130.136 19.4965ZM128.472 17.3886H130.034C130.761 17.3886 131.373 17.2598 131.869 17.0022C132.369 16.7408 132.744 16.3374 132.994 15.792C133.248 15.2427 133.375 14.5344 133.375 13.667C133.375 12.8071 133.248 12.1045 132.994 11.559C132.744 11.0136 132.371 10.612 131.875 10.3545C131.379 10.0969 130.767 9.9681 130.04 9.9681H128.472V17.3886Z",
    fill: "#008F11"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M137.652 19.4965V7.86014H145.357V9.88855H140.112V12.6613H144.845V14.6897H140.112V19.4965H137.652Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogoIcon);
export default __webpack_public_path__ + "static/media/footer-logo-icon.8ea13ac9c9ea801cb146e9cdadf6ac93.svg";
export { ForwardRef as ReactComponent };